import React, { useCallback, useContext, useState } from 'react';
import translate from '../../../commonComponents/translate';
import NetworkListTable from './NetworkListTable';
import NetworkListDateInfo from './NetworkListDateInfo';
import NetworkListFilters from './NetworkListFilters';
import ConfigsContext from '../../../contextProviders/ConfigsContext';
import { getInitialState } from '../helpers/auxiliarTreeHelper';

const defaultFilters = {
  search: null,
  sponsoredBy: null,
  recruitedBy: null,
  level: null,
  showInvited: false,
  user: null,
};

const concatenateFilters = (baseString, filters) => {
  const filterParams = [];

  for (const key in filters) {
    if (filters[key] !== null) {
      filterParams.push(`${key}=${filters[key]}`);
    }
  }

  if (filterParams.length > 0) {
    const filterString = filterParams.join('&');
    return `${baseString}${filterString}`;
  }
  return baseString;
};

function NetworkList() {
  /** region Handle Filters */

  const { organization = {} } = useContext(ConfigsContext);
  const { recurrence } = organization?.directSelling || {};
  const initialState = getInitialState(recurrence);
  const [filters, setFilters] = useState({
    ...defaultFilters,
    startDate: initialState.startDate,
    endDate: initialState.endDate,
    datePicker: initialState.rangeType,
  });

  const handleFilters = useCallback(
    field => value => {
      switch (field) {
        case 'showInvited':
          setFilters(prevFilters => ({
            ...prevFilters,
            showInvited: !prevFilters.showInvited,
          }));
          break;
        default:
          setFilters(prevFilters => ({ ...prevFilters, [field]: value }));
          break;
      }
    },
    [setFilters],
  );
  /** endregion */

  const handleClearFilters = useCallback(
    () => setFilters(initialState),
    [setFilters],
  );

  const handleDateChange = useCallback(
    (startDate, endDate, rangeType) => {
      setFilters(prevState => ({
        ...prevState,
        startDate,
        endDate,
        datePicker: rangeType,
      }));
    },
    [setFilters],
  );
  // Export list excel
  const handleExportList = useCallback(() => {
    const endpoint = concatenateFilters(
      '/excel/user/network/xlsx?gamificationAPI=Organization&populate=sponsoredBy&populate=recruitedBy&',
      {
        ...filters,
        showInvited: filters.showInvited ? filters.showInvited : null,
        search:
          filters.search && filters.search.length > 0 ? filters.search : null,
      },
    );
    window.open(endpoint);
  }, [filters]);

  return (
    <div className="m-portlet__body" id="networkListTab">
      <NetworkListDateInfo />
      <NetworkListFilters
        filters={filters}
        onFiltersChange={handleFilters}
        onExportList={handleExportList}
        onClearFilters={handleClearFilters}
        onDateChange={handleDateChange}
      />
      <NetworkListTable filters={filters} />
    </div>
  );
}

NetworkList.propTypes = {};

export default translate(NetworkList);
